export const contentFocusTopBrandIdsAndLogos = [
  {
    id: '53709', // NIKE
    img: {
      backgroundBOHash: '660b951d2ad056a02e4bbb8b470938c6.jpg',
      logo: {
        w: 90,
        h: 50,
      },
    },
  },
  {
    id: '364', // Tommy Hilfiger
    img: {
      backgroundBOHash: '0f905a68a42af3fd925c6a6a11695c3b.jpg',
      logo: {
        w: 130,
        h: 70,
      },
    },
  },
  {
    id: '290', // Adidas
    img: {
      backgroundBOHash: '732a55ba1a70e4ad4ee7cfb787f89cb3.jpg',
      logo: {
        w: 90,
        h: 50,
      },
    },
  },
  {
    id: '226', // Levi's
    img: {
      backgroundBOHash: 'cdf92fc38f5d9f28f08e1eadc041e353.jpg',
      logo: {
        w: 90,
        h: 50,
      },
    },
  },
  {
    id: '389', // Calvin Klein
    img: {
      backgroundBOHash: 'e751089508e513b25e4704be8f4c8638.jpg',
      logo: {
        w: 100,
        h: 60,
      },
    },
  },
  {
    id: '4352', // Polo Ralph Lauren
    img: {
      backgroundBOHash: 'f5ef25a1eeda0f4cf59d83749d609224.jpg',
      logo: {
        w: 110,
        h: 70,
      },
    },
  },
  // fallbacks
  {
    id: '182', // Puma
    img: {
      backgroundBOHash: '4d7b485834a254061ad89b428122ded6.jpg',
      logo: {
        w: 110,
        h: 70,
      },
    },
  },
  {
    id: '480', // Lacoste
    img: {
      backgroundBOHash: '57f15f4078854a75e06222ab2efc6185.jpg',
      logo: {
        w: 100,
        h: 60,
      },
    },
  },
  {
    id: '278', // Reebok
    img: {
      backgroundBOHash: '5e469bc7fee919d6213e44d12cc1da38.jpg',
      logo: {
        w: 100,
        h: 60,
      },
    },
  },
  {
    id: '305', // Pepe 🐸
    img: {
      backgroundBOHash: '021a77c5a5ef6d76ff14bf9b2aaa54d7.jpg',
      logo: {
        w: 110,
        h: 70,
      },
    },
  },
  {
    id: '5155', // GAP
    img: {
      backgroundBOHash: '31835be0a3a78ac4d0521f8d7485a733.jpg',
      logo: {
        w: 110,
        h: 70,
      },
    },
  },
]
